import { writable } from "svelte/store";

// Process
export const step = writable(-1);
export const bookingStep = writable(1);
export const type = writable("booking");
export const typeOption = writable("Booking");
export const parentElement = writable("");
export const source = writable("general");

export const offer = writable(false);

export const SqPayment = writable(null);

export const openLocationDropdown = writable(false);

export const flashSale = writable([]);
export const hasFlashSale = writable(false);
export const selectedFlashSaleTimeslot = writable(null);

export const showBookingModal = writable(false);

export const paymentSectionVisibility = writable(true);
export const bypassPayment = writable(false);

export const hasGroupon = writable(false);
export const validGroupon = writable(false);
export const grouponCode = writable(null);
export const grouponInfo = writable({
  code: null,
  length: null,
  location: null,
  people: null,
  type: null
});

// Location
// export const location = writable('');
export const location = writable({
  id: null,
  name: null,
  country: null,
  address: null,
  phone: null,
  rateWalkin: null,
  region: null,
  hasOtherLocation: false,
  timeslots: [],
  dayTimeslots: [],
  blockedDates: [],
  groups: [],
  moneySign: "",
  rates: {
    normal: "",
    walkin: "",
    hero: "",
    corporate: "",
  },
  pricing: {
    regular: "",
    group: "",
    prime: "",
    regular_1: "",
    regular_2: "",
    regular_3: "",
    regular_4: "",
    flash_sale_1: "",
    flash_sale_2: "",
    flash_sale_3: "",
    flash_sale_4: "",
    advanced_booking_1: "",
    advanced_booking_2: "",
    advanced_booking_3: "",
    advanced_booking_4: "",
    lanes_1: "",
    lanes_2: "",
    lanes_3: "",
    lanes_4: "",
    lanes_5: "",
    lanes_6: "",
    lanes_7: "",
    lanes_8: "",
    lanes_9: "",
    lanes_10: "",
    lanes_11: "",
    lanes_12: "",
    lanes_13: "",
    lanes_14: "",
  },
  occasions: null,
});
export const locations = writable([]);

// Book
export const book = writable({
  date: null,
  dateString: null,
  timeslot: null,
  groupsize: null,
  shirt: null,
  medallion: null,
  location: null,
  user: {
    fullName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    occasion: "",
    aproxGroupSize: "",
    notes: "",
  },
  policiesAccepted: 0,
  policiesToAccept: ["terms-and-conditions"],
  reference: null,
  knifeAddon: false,
  bigAxeAddon: false,
  bookingExtension: false,
  corkageAddon: false,
  hasAddons: false,
  lanes: 1,
});

export const paymentControl = writable({
  process: false,
  completed: false,
  informationCompleted: false,
  readyToSend: false,
  submit: false,
});

export const bookLocation = writable("");

// Reset booking state
export const resetBooking = () => {
  // Reset main booking stores
  step.set(-1);
  bookingStep.set(1);
  type.set("booking");
  typeOption.set("Booking");

  book.set({
    date: null,
    dateString: null,
    timeslot: null,
    groupsize: null,
    shirt: null,
    medallion: null,
    location: null,
    user: {
      fullName: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      occasion: "",
      aproxGroupSize: "",
      notes: "",
    },
    policiesAccepted: 0,
    policiesToAccept: ["terms-and-conditions"],
    reference: null,
    knifeAddon: false,
    bigAxeAddon: false,
    bookingExtension: false,
    corkageAddon: false,
    hasAddons: false,
    lanes: 1,
  });

  paymentControl.set({
    process: false,
    completed: false,
    informationCompleted: false,
    readyToSend: false,
    submit: false,
  });

  bookLocation.set("");
};

// User
export const user = writable({
  email: "",
  fullName: "",
  firstName: "",
  lastName: "",
  company: "",
  phone: "",
});

// Policies
export const policies = writable({
  agreedCancellation: false,
  agreedLargeGroup: false,
  agreedHoliday: false,
  agreedOverAge: false,
  agreedLastMinue: false,
});


// Social Lanes
export const socialLanes = writable([]);

